import { Experiment } from '@ms/yammer-data/dist/state/ecsExperiments/types';

import { useExperimentTreatmentWithoutReporting } from '../experiments';
import { useIsNetworkQuestionsAIFeaturesEnabled } from '../featureAccessSettings';

type UseShouldShowCuratedThreadLists = () => boolean;
export const useShouldShowCuratedThreadLists: UseShouldShowCuratedThreadLists = () => {
  const isFAQifyEnabled = useExperimentTreatmentWithoutReporting(Experiment.FAQIfy) === 'enabled';
  const isNetworkQuestionsAIFeaturesEnabled = !!useIsNetworkQuestionsAIFeaturesEnabled();

  return isFAQifyEnabled && isNetworkQuestionsAIFeaturesEnabled;
};
